import { createSlice } from '@reduxjs/toolkit'
import { setCookie, removeCookie, getCookie } from '../../utils/cookieUtils'

// Replace localStorage implementation in the initial state
const initialState = {
  user: null,
  bag: null,
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.user = action.payload
      state.isAuthenticated = true
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.bag = null
      removeCookie('bag')
      removeCookie('cart')
    },
    setBag: (state, action) => {
      state.bag = action.payload
      setCookie('bag', action.payload)
    },
  },
})

export const { signIn, logout, setBag } = authSlice.actions
export default authSlice.reducer
